import React from "react";

import { Field } from "react-final-form";
//@ts-ignore
import { OnChange } from "react-final-form-listeners";

// https://medium.com/@erikras/declarative-form-rules-c5949ea97366
export const WhenFieldChanges = ({ field, condition, set, to }: any) => (
  <Field name={set} subscription={{}}>
    {(
      // No subscription. We only use Field to get to the change function
      { input: { onChange } }
    ) => (
      <OnChange name={field}>
        {(value: any) => {
          if (condition(value)) {
            onChange(to);
          }
        }}
      </OnChange>
    )}
  </Field>
);
